var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPieUnverifiedSign = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13581",
    "data-name": "Rectangle 13581",
    width: 24,
    height: 24,
    transform: "translate(-4 -4)",
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_48336",
    "data-name": "Path 48336",
    d: "M15.776,1.421,14.671.329a.793.793,0,0,0-1.105,0L8.052,5.842,2.435.225a.793.793,0,0,0-1.105,0L.225,1.33a.793.793,0,0,0,0,1.105l5.6,5.6-5.5,5.526a.793.793,0,0,0,0,1.105l1.105,1.105a.793.793,0,0,0,1.105,0l5.513-5.513,5.513,5.513a.793.793,0,0,0,1.105,0l1.105-1.105a.793.793,0,0,0,0-1.105L10.25,8.052l5.513-5.513A.8.8,0,0,0,15.776,1.421Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPieUnverifiedSign);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pie_unverified_sign.e75012a195402b1f9d54339c8565da6d.svg";